import { render, staticRenderFns } from "./AscCloseButton.vue?vue&type=template&id=2b1e0214&scoped=true&"
import script from "./AscCloseButton.vue?vue&type=script&lang=js&"
export * from "./AscCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./AscCloseButton.vue?vue&type=style&index=0&id=2b1e0214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e0214",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
